export default __webpack_public_path__ + "static/media/file-text.105b5d20.svg";